import { h, Component } from 'preact'
import styled from 'styled-components'
import Underlined from '../../components/atoms/underlined'

const Card = styled.a`
  width: 100%;
  height: 160px;
  background-color: white;
  display: inline-block;
  text-align: center;
  position: relative;
  padding-top: 30px;
  color: black;
  text-decoration: none;
  transition: background-color 0.2s;
  :hover {
    background-color: #eee;
  }
`

function percentToColor(v) {
  if (v < 20) return 'rgb(221, 30, 34)'
  if (v < 50) return 'rgb(235, 168, 8)'
  if (v < 80) return 'rgb(146, 200, 72)'
  return 'rgb(67, 113, 26)'
}

const Bar = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 9px;
  background-color: ${props => percentToColor(props.percent)};
  width: ${props => props.percent}%;
`

const Name = Underlined.extend`
  font-weight: bold;
`

const CardOuter = styled.div`
  width: 237px;
  padding: 0 1px 1px 0;
  :hover ${Name}::after {
    opacity: 0;
  }
`

export default class ResultCard extends Component {
  render({ percent, name, surname, party, id }) {
    return (
      <CardOuter>
        <Card href={`/hlas/${id}`}>
          <Bar percent={percent} />
          <div>{percent === false ? '-' : `${percent}%`}</div>
          <div>
            <Name>{name.trim()}</Name>
          </div>
          <div>
            <Name>{surname.trim()}</Name>
          </div>
          <div>{party}</div>
        </Card>
      </CardOuter>
    )
  }
}



// WEBPACK FOOTER //
// ./routes/home/resultcard.js